import LiquidacionCreateView from './views/LiquidacionCreateView.vue'
import LiquidacionesListView from './views/LiquidacionesListView.vue'
import LiquidacionesView from './views/LiquidacionesView.vue'

export default [
  {
    path: '/liquidacion-nueva',
    name: 'nuevaLiquidacion',
    component: LiquidacionCreateView
  },
  {
    path: '/liquidaciones',
    name: 'liquidacionestv',
    component: LiquidacionesListView
  },
  {
    path: '/liquidacion/:id',
    name: 'detalleLiquidacion',
    component: LiquidacionesView
  }
]
